import { defineComponent as m, ref as u, computed as b, createBlock as i, openBlock as n, unref as c, createSlots as x, withCtx as t, createTextVNode as l, toDisplayString as a, createElementVNode as k, normalizeClass as h, createCommentVNode as v } from "vue";
import { RevListItemInteractive as y } from "@ds/components/ListItemInteractive";
import S from "../../../icons/generated/IconCheckLarge.vue2.js";
import { tw as o } from "../../../utils/tailwind.js";
import p from "./ListItemPlaceholder.vue2.js";
const z = /* @__PURE__ */ m({
  __name: "InputSelectSearchableItem",
  props: {
    hideCheckbox: { type: Boolean, default: !1 },
    isSelected: { type: Boolean },
    label: {},
    description: { default: null },
    suffix: { default: null },
    listboxElement: {}
  },
  setup(e) {
    const r = e, s = u(!1);
    function d() {
      s.value = !0;
    }
    const f = b(() => [
      o`rounded-sm pointer-events-none mt-2 flex size-20 items-center justify-center ease-in motion-safe:transition-colors motion-safe:duration-[50ms]`,
      r.isSelected ? o`bg-action-default-low-pressed text-onaction-default-low-pressed` : o`bg-action-default-low border-static-default-hi border`
    ]);
    return (C, I) => s.value ? (n(), i(c(y), {
      key: 0,
      "aria-label": e.label,
      "aria-selected": String(e.isSelected),
      role: "option",
      tabindex: "-1"
    }, x({
      label: t(() => [
        l(a(e.label), 1)
      ]),
      _: 2
    }, [
      e.hideCheckbox ? void 0 : {
        name: "prefix",
        fn: t(() => [
          k("div", {
            class: h(f.value)
          }, [
            e.isSelected ? (n(), i(c(S), {
              key: 0,
              size: "16"
            })) : v("", !0)
          ], 2)
        ]),
        key: "0"
      },
      e.description ? {
        name: "description",
        fn: t(() => [
          l(a(e.description), 1)
        ]),
        key: "1"
      } : void 0,
      e.suffix ? {
        name: "suffix",
        fn: t(() => [
          l(a(e.suffix), 1)
        ]),
        key: "2"
      } : void 0
    ]), 1032, ["aria-label", "aria-selected"])) : (n(), i(p, {
      key: 1,
      class: "min-h-64",
      "listbox-element": e.listboxElement,
      onIntersect: d
    }, null, 8, ["listbox-element"]));
  }
});
export {
  z as default
};
